/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-2/12 md:w-2/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank flex flex-wrap gap-4">
              <h5 class="dragBlock font-semibold cursor-pointer">input</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">)</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">end=";"</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">sep=";"</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">x, y,</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">(</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">";"</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">print</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-10/12 md:w-10/12 sm:w-5/5">
          <div class="main-border rounded-lg bg-dark p-6">
            <h2 class="font-bold mb-5">x, y = 1.5, 3.8</h2>
            <div class="grid grid-cols-5 gap-3">
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input0" />
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input1" />
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input2" />
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input3" />
              <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input4" />
            </div>
          </div>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('input0').textContent === 'print') {
        document.getElementById('input0').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input1').textContent === '(') {
        document.getElementById('input1').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input2').textContent === 'x, y,') {
        document.getElementById('input2').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input3').textContent === 'sep=";"') {
        document.getElementById('input3').style.borderColor = '#28C76F';
        totalScore++;
      }
      if (document.getElementById('input4').textContent === ')') {
        document.getElementById('input4').style.borderColor = '#28C76F';
        totalScore++;
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      return this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
